import React, { useState, useEffect } from 'react';
import axios from 'axios';

const EgitimYonetimiPage = () => {
  const [egitimler, setEgitimler] = useState([]);
  const [personeller, setPersoneller] = useState([]);
  const [seciliEgitim, setSeciliEgitim] = useState(null);
  const [form, setForm] = useState({ ad: '', aciklama: '', platform_link: '', sure_gun: '', siradaki_egitim_id: '' });
  const [formAcik, setFormAcik] = useState(false);
  const [duzenle, setDuzenle] = useState(null);
  const [seciliPersoneller, setSeciliPersoneller] = useState([]);
  const [notlar, setNotlar] = useState('');
  const [personelArama, setPersonelArama] = useState('');
  const [departmanFiltre, setDepartmanFiltre] = useState('');
  const [egitimArama, setEgitimArama] = useState('');
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [detayAtamalar, setDetayAtamalar] = useState([]);
  const [aktifSekme, setAktifSekme] = useState('ata');

  const yukle = async () => {
    try { const res = await axios.get('/api/egitim'); setEgitimler(res.data); }
    catch(err) { console.error(err); }
  };

  const personelYukle = async () => {
    try { const res = await axios.get('/api/personel-karti'); setPersoneller(res.data); }
    catch(err) { console.error(err); }
  };

  useEffect(() => { yukle(); personelYukle(); }, []);

  const egitimDetayAc = async (egitim) => {
    setSeciliEgitim(egitim);
    setSonuc(null); setSeciliPersoneller([]); setNotlar('');
    setPersonelArama(''); setDepartmanFiltre(''); setAktifSekme('ata');
    try {
      const res = await axios.get('/api/egitim/' + egitim.id);
      setDetayAtamalar(res.data.atamalar || []);
    } catch(err) { console.error(err); }
  };

  const handleSubmit = async e => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      if (duzenle) { await axios.put('/api/egitim/' + duzenle, form); setSonuc({ tip: 'basari', mesaj: 'Egitim guncellendi.' }); }
      else { await axios.post('/api/egitim', form); setSonuc({ tip: 'basari', mesaj: 'Egitim olusturuldu.' }); }
      setForm({ ad: '', aciklama: '', platform_link: '', sure_gun: '', siradaki_egitim_id: '' });
      setFormAcik(false); setDuzenle(null); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const handleAta = async () => {
    if (!seciliPersoneller.length) { setSonuc({ tip: 'hata', mesaj: 'En az bir personel secin.' }); return; }
    setYukleniyor(true);
    try {
      const res = await axios.post('/api/egitim/' + seciliEgitim.id + '/ata', { kullanici_idler: seciliPersoneller, notlar });
      setSonuc({ tip: 'basari', mesaj: res.data.mesaj });
      setSeciliPersoneller([]); setNotlar('');
      const detay = await axios.get('/api/egitim/' + seciliEgitim.id);
      setDetayAtamalar(detay.data.atamalar || []);
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const togglePersonel = (id) => setSeciliPersoneller(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const fmt = t => t ? new Date(t).toLocaleDateString('tr-TR') : '-';

  const durumBadge = (durum, bitis) => {
    if (durum === 'tamamlandi') return <span className="badge badge-tamamlandi">Tamamlandi</span>;
    if (bitis && new Date(bitis) < new Date()) return <span className="badge badge-hata">Suresi Gecti</span>;
    return <span className="badge badge-bekliyor">Devam Ediyor</span>;
  };

  // DETAY SAYFASI
  if (seciliEgitim) {
    const atananIdler = detayAtamalar.filter(a => a.durum !== 'tamamlandi').map(a => a.kullanici_id);
    const departmanlar = [...new Set(personeller.map(p => p.departman).filter(Boolean))].sort();
    const filtrelenmisPersoneller = personeller
      .filter(p => !atananIdler.includes(p.id))
      .filter(p => {
        const aramaEsles = !personelArama || (p.ad + ' ' + p.soyad + ' ' + (p.email||'')).toLowerCase().includes(personelArama.toLowerCase());
        const depEsles = !departmanFiltre || p.departman === departmanFiltre;
        return aramaEsles && depEsles;
      });
    const tumunuSec = () => {
      const tumIdler = filtrelenmisPersoneller.map(p => p.id);
      const hepsiSecili = tumIdler.every(id => seciliPersoneller.includes(id));
      if (hepsiSecili) setSeciliPersoneller(prev => prev.filter(id => !tumIdler.includes(id)));
      else setSeciliPersoneller(prev => [...new Set([...prev, ...tumIdler])]);
    };
    const tumunuSecili = filtrelenmisPersoneller.length > 0 && filtrelenmisPersoneller.every(p => seciliPersoneller.includes(p.id));
    const tamamlanan = detayAtamalar.filter(a => a.durum === 'tamamlandi').length;
    const devamEden = detayAtamalar.filter(a => a.durum !== 'tamamlandi').length;

    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '1.5rem' }}>
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => { setSeciliEgitim(null); setSonuc(null); }}>← Geri</button>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px' }}>
              <h2 style={{ fontSize: '22px' }}>{seciliEgitim.ad}</h2>
              {seciliEgitim.siradaki_ad && <span style={{ fontSize: '11px', color: 'var(--mavi)', background: 'var(--mavi-acik)', padding: '2px 8px', borderRadius: '4px' }}>Zincir → {seciliEgitim.siradaki_ad}</span>}
            </div>
            {seciliEgitim.aciklama && <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>{seciliEgitim.aciklama}</p>}
            <div style={{ display: 'flex', gap: '1.5rem', fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '6px' }}>
              <span>⏱ {seciliEgitim.sure_gun > 0 ? seciliEgitim.sure_gun + ' gun' : 'Suresiz'}</span>
              {seciliEgitim.platform_link && <a href={seciliEgitim.platform_link} target="_blank" rel="noreferrer" style={{ color: 'var(--mavi)' }}>Platform →</a>}
            </div>
          </div>
        </div>

        <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
          <div className="stat-kart"><div className="stat-sayi">{detayAtamalar.length}</div><div className="stat-etiket">Toplam Atama</div></div>
          <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)' }}>{tamamlanan}</div><div className="stat-etiket">Tamamlandi</div></div>
          <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--sari)' }}>{devamEden}</div><div className="stat-etiket">Devam Ediyor</div></div>
          <div className="stat-kart"><div className="stat-sayi">{detayAtamalar.length > 0 ? Math.round(tamamlanan / detayAtamalar.length * 100) : 0}%</div><div className="stat-etiket">Tamamlanma</div></div>
        </div>

        {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

        <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: '1.5rem' }}>
          {[{ key: 'ata', label: 'Personel Ata', count: filtrelenmisPersoneller.length }, { key: 'atamalar', label: 'Mevcut Atamalar', count: detayAtamalar.length }].map(s => (
            <button key={s.key} type="button" onClick={() => setAktifSekme(s.key)}
              style={{ padding: '0.6rem 1.25rem', border: 'none', background: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: aktifSekme === s.key ? '600' : '400', color: aktifSekme === s.key ? 'var(--mavi)' : 'var(--yazi-ikincil)', borderBottom: aktifSekme === s.key ? '2px solid var(--mavi)' : '2px solid transparent' }}>
              {s.label} <span style={{ fontSize: '12px', background: aktifSekme === s.key ? 'var(--mavi)' : 'var(--gri-200)', color: aktifSekme === s.key ? 'white' : 'var(--yazi-ikincil)', padding: '1px 6px', borderRadius: '10px', marginLeft: '4px' }}>{s.count}</span>
            </button>
          ))}
        </div>

        {aktifSekme === 'ata' && (
          <div className="card">
            <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', flexWrap: 'wrap' }}>
              <input type="text" placeholder="İsim, email ara..." value={personelArama} onChange={e => setPersonelArama(e.target.value)} autoComplete="off" style={{ flex: 1, minWidth: '160px', fontSize: '13px' }} />
              <select value={departmanFiltre} onChange={e => setDepartmanFiltre(e.target.value)} style={{ fontSize: '13px', minWidth: '140px' }}>
                <option value="">Tum Departmanlar</option>
                {departmanlar.map(d => <option key={d} value={d}>{d}</option>)}
              </select>
            </div>
            {filtrelenmisPersoneller.length > 0 && (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', marginBottom: '8px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
                  <input type="checkbox" checked={tumunuSecili} onChange={tumunuSec} />
                  Tumunu Sec ({filtrelenmisPersoneller.length} personel)
                </label>
                {seciliPersoneller.length > 0 && <span style={{ fontSize: '12px', color: 'var(--mavi)', fontWeight: '500' }}>{seciliPersoneller.length} secildi</span>}
              </div>
            )}
            <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)', marginBottom: '1rem' }}>
              {filtrelenmisPersoneller.length === 0 ? (
                <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--yazi-ikincil)', fontSize: '13px' }}>
                  {personeller.filter(p => !atananIdler.includes(p.id)).length === 0 ? 'Tum personel bu egitime atanmis.' : 'Arama sonucu bulunamadi.'}
                </div>
              ) : filtrelenmisPersoneller.map((p, i) => (
                <label key={p.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 10px', cursor: 'pointer', background: seciliPersoneller.includes(p.id) ? 'var(--mavi-acik)' : i % 2 === 0 ? 'white' : 'var(--gri-50)', borderBottom: '1px solid var(--gri-100)', transition: 'background 0.1s', minWidth: 0 }}>
                  <input type="checkbox" checked={seciliPersoneller.includes(p.id)} onChange={() => togglePersonel(p.id)} />
                  <div className="avatar" style={{ width: '32px', height: '32px', fontSize: '12px', flexShrink: 0, background: seciliPersoneller.includes(p.id) ? 'var(--mavi)' : 'var(--mavi-acik)', color: seciliPersoneller.includes(p.id) ? 'white' : 'var(--mavi)' }} data-harf={p.ad[0] || '?'}>{p.ad[0]}{p.soyad[0]}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '13px', fontWeight: '500', color: seciliPersoneller.includes(p.id) ? 'var(--mavi)' : 'var(--yazi)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.ad} {p.soyad}</div>
                    <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)' }}>{[p.departman, p.pozisyon].filter(Boolean).join(' · ')}</div>
                  </div>
                </label>
              ))}
            </div>
            {seciliPersoneller.length > 0 && (
              <div style={{ background: 'var(--mavi-acik)', borderRadius: 'var(--radius-sm)', padding: '10px 12px', marginBottom: '0.75rem' }}>
                <div style={{ fontSize: '13px', color: 'var(--mavi)', fontWeight: '600', marginBottom: '6px' }}>✓ {seciliPersoneller.length} personel secildi</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                  {seciliPersoneller.slice(0, 6).map(id => { const p = personeller.find(x => x.id === id); return p ? <span key={id} style={{ fontSize: '11px', background: 'white', color: 'var(--mavi)', padding: '2px 8px', borderRadius: '12px' }}>{p.ad} {p.soyad}</span> : null; })}
                  {seciliPersoneller.length > 6 && <span style={{ fontSize: '11px', color: 'var(--mavi)' }}>+{seciliPersoneller.length - 6} daha</span>}
                </div>
              </div>
            )}
            <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end' }}>
              <div className="form-group" style={{ flex: 1, margin: 0 }}>
                <label>Not (opsiyonel)</label>
                <input type="text" value={notlar} onChange={e => setNotlar(e.target.value)} placeholder="Atama notu..." autoComplete="off" />
              </div>
              <button type="button" className="btn btn-primary" onClick={handleAta} disabled={yukleniyor || !seciliPersoneller.length} style={{ whiteSpace: 'nowrap', minHeight: '42px' }}>
                {yukleniyor ? 'Ataniyor...' : seciliPersoneller.length > 0 ? `${seciliPersoneller.length} Kisiye Ata` : 'Personel Secin'}
              </button>
            </div>
          </div>
        )}

        {aktifSekme === 'atamalar' && (
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            {detayAtamalar.length === 0 ? (
              <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>Henuz atama yapilmadi.</div>
            ) : (
              <div className="tablo-wrapper">
                <table>
                  <thead><tr><th>Personel</th><th>Atanma</th><th>Bitis</th><th>Tamamlanma</th><th>Durum</th></tr></thead>
                  <tbody>
                    {detayAtamalar.map(a => (
                      <tr key={a.id}>
                        <td><div style={{ fontWeight: '500', fontSize: '14px' }}>{a.ad} {a.soyad}</div><div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{a.email}</div></td>
                        <td style={{ fontSize: '13px' }}>{fmt(a.atama_tarihi)}</td>
                        <td style={{ fontSize: '13px' }}>{fmt(a.bitis_tarihi)}</td>
                        <td style={{ fontSize: '13px' }}>{fmt(a.tamamlanma_tarihi)}</td>
                        <td>{durumBadge(a.durum, a.bitis_tarihi)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  // ANA LİSTE SAYFASI
  const toplamAtama = egitimler.reduce((t, e) => t + (e.atama_sayisi || 0), 0);
  const toplamTamamlanan = egitimler.reduce((t, e) => t + (e.tamamlanan_sayisi || 0), 0);
  const filtrelenmisEgitimler = egitimler.filter(eg =>
    !egitimArama || eg.ad.toLowerCase().includes(egitimArama.toLowerCase()) || (eg.aciklama||'').toLowerCase().includes(egitimArama.toLowerCase())
  );

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem', marginBottom: '1.5rem' }}>
        <div>
          <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Egitim Yonetimi</h2>
          <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Egitimleri tanimlayin, karta tiklayarak atama yapin.</p>
        </div>
        <button type="button" className="btn btn-primary" onClick={() => { setFormAcik(!formAcik); setDuzenle(null); setForm({ ad: '', aciklama: '', platform_link: '', sure_gun: '', siradaki_egitim_id: '' }); setSonuc(null); }}>
          {formAcik ? 'Iptal' : '+ Yeni Egitim'}
        </button>
      </div>

      {/* Genel istatistikler */}
      {egitimler.length > 0 && (
        <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
          <div className="stat-kart"><div className="stat-sayi">{egitimler.length}</div><div className="stat-etiket">Toplam Egitim</div></div>
          <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--mavi)' }}>{toplamAtama}</div><div className="stat-etiket">Toplam Atama</div></div>
          <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)' }}>{toplamTamamlanan}</div><div className="stat-etiket">Tamamlanan</div></div>
          <div className="stat-kart"><div className="stat-sayi">{toplamAtama > 0 ? Math.round(toplamTamamlanan / toplamAtama * 100) : 0}%</div><div className="stat-etiket">Genel Oran</div></div>
        </div>
      )}

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      {formAcik && (
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div className="card-header"><h2>{duzenle ? 'Egitimi Duzenle' : 'Yeni Egitim Ekle'}</h2></div>
          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group full"><label>Egitim Adi *</label><input type="text" value={form.ad} onChange={e => setForm({ ...form, ad: e.target.value })} required /></div>
              <div className="form-group full"><label>Kisa Aciklama</label><textarea value={form.aciklama} onChange={e => setForm({ ...form, aciklama: e.target.value })} rows={3} /></div>
              <div className="form-group full"><label>Platform Linki</label><input type="url" placeholder="https://..." value={form.platform_link} onChange={e => setForm({ ...form, platform_link: e.target.value })} /></div>
              <div className="form-group"><label>Tamamlanma Suresi (Gun) — 0 = Suresiz</label><input type="number" min="0" value={form.sure_gun} onChange={e => setForm({ ...form, sure_gun: e.target.value })} /></div>
              <div className="form-group">
                <label>Siradaki Egitim (Zincir)</label>
                <select value={form.siradaki_egitim_id} onChange={e => setForm({ ...form, siradaki_egitim_id: e.target.value })}>
                  <option value="">— Yok —</option>
                  {egitimler.filter(eg => eg.id !== duzenle).map(eg => <option key={eg.id} value={eg.id}>{eg.ad}</option>)}
                </select>
              </div>
            </div>
            <div style={{ marginTop: '1rem', display: 'flex', gap: '8px' }}>
              <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
              <button type="button" className="btn btn-secondary" onClick={() => { setFormAcik(false); setDuzenle(null); }}>Iptal</button>
            </div>
          </form>
        </div>
      )}

      {/* Arama */}
      {egitimler.length > 0 && (
        <div style={{ marginBottom: '1rem' }}>
          <input type="text" placeholder="Egitim ara..." value={egitimArama} onChange={e => setEgitimArama(e.target.value)} autoComplete="off"
            style={{ width: '100%', maxWidth: '360px', fontSize: '13px' }} />
        </div>
      )}

      {egitimler.length === 0 && !formAcik && (
        <div className="card" style={{ textAlign: 'center', padding: '4rem', color: 'var(--yazi-ikincil)' }}>
          <div style={{ fontSize: '48px', marginBottom: '1rem' }}>📚</div>
          <div style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>Henuz egitim tanimlanmadi</div>
          <p style={{ fontSize: '13px' }}>Yeni egitim ekleyerek personellerinize atama yapabilirsiniz.</p>
        </div>
      )}

      {filtrelenmisEgitimler.length === 0 && egitimArama && (
        <div className="card" style={{ textAlign: 'center', padding: '2rem', color: 'var(--yazi-ikincil)' }}>Arama sonucu bulunamadi.</div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1rem' }}>
        {filtrelenmisEgitimler.map(eg => {
          const oran = eg.atama_sayisi > 0 ? Math.round((eg.tamamlanan_sayisi || 0) / eg.atama_sayisi * 100) : 0;
          return (
            <div key={eg.id} className="card" style={{ cursor: 'pointer', transition: 'all 0.2s', position: 'relative' }}
              onClick={() => egitimDetayAc(eg)}
              onMouseEnter={e => { e.currentTarget.style.boxShadow = 'var(--shadow-md)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = 'var(--shadow)'; e.currentTarget.style.transform = 'translateY(0)'; }}>

              {/* Ust kisim */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem', marginBottom: '10px' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h3 style={{ fontSize: '15px', fontWeight: '600', marginBottom: '4px', fontFamily: 'DM Sans, sans-serif' }}>{eg.ad}</h3>
                  {eg.aciklama && <p style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', lineHeight: '1.4' }}>{eg.aciklama.slice(0, 70)}{eg.aciklama.length > 70 ? '...' : ''}</p>}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px', marginLeft: '8px' }}>
                  {eg.siradaki_ad && <span style={{ fontSize: '10px', color: 'var(--mavi)', background: 'var(--mavi-acik)', padding: '2px 6px', borderRadius: '4px', whiteSpace: 'nowrap' }}>Zincir</span>}
                  {eg.platform_link && <span style={{ fontSize: '10px', color: 'var(--yesil)', background: 'var(--yesil-acik)', padding: '2px 6px', borderRadius: '4px' }}>Platform</span>}
                </div>
              </div>

              {/* Bilgi satirlari */}
              <div style={{ display: 'flex', gap: '12px', fontSize: '12px', color: 'var(--yazi-ikincil)', marginBottom: '12px', flexWrap: 'wrap' }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>⏱ {eg.sure_gun > 0 ? eg.sure_gun + ' gun' : 'Suresiz'}</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>👥 {eg.atama_sayisi || 0} atama</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '4px', color: 'var(--yesil)' }}>✅ {eg.tamamlanan_sayisi || 0} tamamlandi</span>
              </div>

              {/* Progress bar */}
              <div style={{ marginBottom: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: 'var(--yazi-ikincil)', marginBottom: '4px' }}>
                  <span>Tamamlanma</span>
                  <span style={{ fontWeight: '600', color: oran >= 80 ? 'var(--yesil)' : oran >= 40 ? 'var(--sari)' : 'var(--yazi-ikincil)' }}>{oran}%</span>
                </div>
                <div style={{ height: '6px', background: 'var(--gri-100)', borderRadius: '3px' }}>
                  <div style={{ height: '100%', borderRadius: '3px', width: oran + '%', transition: 'width 0.4s', background: oran >= 80 ? 'var(--yesil)' : oran >= 40 ? '#f59e0b' : 'var(--mavi)' }} />
                </div>
              </div>

              {/* Alt kisim */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '11px', color: 'var(--yazi-ikincil)' }}>
                  {eg.siradaki_ad ? '→ ' + eg.siradaki_ad : ''}
                </span>
                <button type="button" className="btn btn-secondary btn-sm"
                  onClick={e => { e.stopPropagation(); setDuzenle(eg.id); setForm({ ad: eg.ad, aciklama: eg.aciklama||'', platform_link: eg.platform_link||'', sure_gun: eg.sure_gun||'', siradaki_egitim_id: eg.siradaki_egitim_id||'' }); setFormAcik(true); setSonuc(null); }}>
                  Duzenle
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default EgitimYonetimiPage;
